"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var TextDataKeyFrame_1 = require("./TextDataKeyFrame");
var TextData = (function (_super) {
    tslib_1.__extends(TextData, _super);
    function TextData(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        if (_this._rawData.k) {
            _this.keyframes = _this._rawData.k.map(function (rawKeyFrame) { return new TextDataKeyFrame_1.TextDataKeyFrame(rawKeyFrame, version); });
        }
        return _this;
    }
    return TextData;
}(AnimationObject_1.AnimationObject));
exports.TextData = TextData;
//# sourceMappingURL=TextData.js.map